<template>
	<div class="rtop-dialog-wrap" v-show="showDialog">
		<CvipDialog @btnClick="topBtnClick()" @close="close()" :title="title" :btnTxt="btnTxt" :disabled="daysUse === 0" v-if="daysUse > 0">
			<p class="info">使用置顶后您的全职简历将在列表顶端展示，更多HR将会看到您的简历。您剩余置顶天数为：<em>{{daysUse}}天</em></p>
			<div class="resume-chose clear">
				<p class="tit inline fl">选择简历：</p>
				<ul class="resume-list fl">
					<li v-for="(item, index) in resumeList" :key="item.confuseResumeId" @click="choseResume(index, item.confuseResumeId)" :class="{checked: choseIndex === index, 'status-toping': item.resumeTopState }" class="resume">{{item.resumeName}}</li>
				</ul>
			</div>
			<p class="tit inline fl">置顶天数：</p>
			<ul class="days-list fl">
				<li v-for="(item, index) in dayList" :key="index" @click="choseDay(item.daysid)" :class="{checked:item.daysid === dayChose, 'unable-day': daysUse < item.daysid}" class="day">{{item.text}}</li>
			</ul>
		</CvipDialog>
		<cvip-alert @on-close="closeConfirm" @on-confirm="onConfirm" buttonTxt="去看看" widthnew='600px' heightnew='260px' marginnew='-100px auto' v-else>
			<h3 style="margin-bottom:20px;">尊贵的会员</h3>
			<p style="line-height:2;">会员套餐中的简历置顶已使用完毕，您可以使用超低的会员价对简历置顶单独购买~</p>
			<p>(设置方式：我的简历--置顶按钮)</p>
		</cvip-alert>
		<!-- 警告 alert -->
		<cvip-alert v-if="showWarn" @on-hide="onHide" buttonTxt="我知道了" widthnew='450px' heightnew='200px' marginnew='-100px auto'>
			<span class="alert-icon icon-warn"></span>
			<span>请选择简历或者置顶天数！</span>
		</cvip-alert>

		<!-- 取消置顶 -->
		<cvip-alert v-if="showCancelWarn" cancelBtnTxt="取消" class="cancel-warn" @on-hide="onHide" @on-confirm="cancelResumeTop" buttonTxt="确定" widthnew='450px' heightnew='200px' marginnew='-100px auto'>
			<span class="alert-icon icon-warn"></span>
			<span>{{ cancelWarnTipText }}</span>
		</cvip-alert>

		<!-- 选择天数大于可使用天数 -->
		<cvip-alert v-if="showDayUseWarn" cancelBtnTxt="取消" class="cancel-warn" @on-hide="onHide" @on-confirm="goRecharge" buttonTxt="去充值" widthnew='450px' heightnew='200px' marginnew='-100px auto'>
			<span class="alert-icon icon-warn"></span>
			<span>您的置顶剩余资源不够</span>
		</cvip-alert>

		<toast v-model="show" class="cancel-toast" :text="toastText"></toast>
	</div>
</template>

<script>
import CvipDialog from "./common/CvipDialog"
import CvipAlert from "../../../../components/alert/Alert"
import Toast from "../../../../components/toast/Toast"
import { cancelResumeTop, getResumeTopInfo } from "@/api/index"

import {
	getResumeHighlight,
	postHighLight
} from '../../../../api/index.js'
export default {
	name: 'RessumeTopDialog',
	data() {
		return {
			showDialog: false,
			title: '简历置顶',
			btnTxt: '立即置顶',
			resume: '',
			resumeList: [], //简历列表
			dayList: [
				{
					daysid: 1,
					text: '1天'
				},
				{
					daysid: 3,
					text: '3天'
				},
				{
					daysid: 5,
					text: '5天'
				},
				{
					daysid: 7,
					text: '7天'
				}
			], //置顶天数可选列表
			choseIndex: -1,
			resumeChose: '', // 选择简历的id
			dayChose: '', // 置顶天数
			daysUse: 1, //剩余天数
			resumeListNum: '',
			addbaseresumeUrl: '',
			showCancelWarn: false,
			cancelWarnTipText: "",
			showWarn: false, // 警告 alert 弹框标志
			showDayUseWarn: false,
			show: false,
			toastText: ""
		}
	},
	computed: {
		resumeChose() {
			return this.resumeList[this.choseIndex].confuseResumeId;
		}
	},
	created() {
		this.init();
	},
	methods: {
		async init(){
			await this.getResumeHighlightFn('pc', 5);

			this.initChoseIndex();
			console.log("");
			
			this.showDialog = true;
		},
		initChoseIndex() {
			for (let i = 0; i < this.resumeList.length; i++) {
				if(!this.resumeList[i].resumeTopState) {
					this.choseIndex = i;
					this.resumeChose = this.resumeList[this.choseIndex].confuseResumeId;
					return;
				}
			}
		},
		close() {
			window.clickLog && window.clickLog('from=pc-cvip-jlzdsz-tanchuang-close')
			this.$emit('closeDialog')
		},
		closeConfirm() {
			window.clickLog && window.clickLog('from=pccvip_zhdiingnewclickno')
			this.$emit('closeDialog')
		},
		async handleGetResumeTopInfo(resumeId) {
			
			const resumeTopInfo = await getResumeTopInfo(resumeId);

			const { isSuccess, entity, returnMessage } = resumeTopInfo;

			if (!isSuccess) {
				this.handleToast(returnMessage)
				return false;
			}

			const days = entity.leftTime < 24 && entity.leftTime >= 0 ? `${entity.leftTime}小时` : `${parseInt(entity.leftTime / 24)}天`

			this.cancelWarnTipText = `当前简历正在置顶中，若取消，剩余${days}天不返还`;
			
		},
		/**
		 * 当前选择的简历
		 */
		async choseResume(index, resumeId) {

			this.resumeChose = this.resumeList[index].confuseResumeId;

			if (this.resumeList[index].resumeTopState) {

				await this.handleGetResumeTopInfo(this.resumeChose);

				this.showCancelWarn = true;

				return;
			}

			if (index === this.choseIndex) {
				return
			}
			this.choseIndex = index;
		},
		cancelResumeTop() {
			this.setCancelResumeTop();
		},
		handleToast(text) {
			this.show = true;
			this.toastText = text;
			setTimeout(() => {
				this.show = false;
			}, 1500);
		},
		// 取消置顶
		async setCancelResumeTop(resumeId) {

			const res = await cancelResumeTop(resumeId || this.resumeChose);

			const { isSuccess } = res;


			if (!isSuccess) {
				this.handleToast("取消置顶失败");
				return false;
			}
	
			this.getResumeHighlightFn('pc', 5);

			this.handleToast("取消置顶成功");
		},
		/**
		 * 当前选择的指定天数
		 */
		choseDay(day) {
			if(day > this.daysUse) {
				this.showDayUseWarn = true;
				return;
			}

			if (day === this.dayChose) {
				return
			}
			this.dayChose = day
		},
		goRecharge() {
			window.open(`https://my.58.com/pro/myjob/index/?autoshowtop=1&PGTID=0d100000-0000-1a0e-61f4-748f61838c3f&ClickID=2`)
			this.showDayUseWarn = false;
		},
		/**
		 * 简历置顶（productid=5）
		 * 剩余置顶天数：daysUse
		 */
		async getResumeHighlightFn(ft, productid) {
			const data = await getResumeHighlight(ft, productid);

			const { isSuccess, entity, returnMessage } = data;

			if (!isSuccess) {
				this.$p5.toast({content: returnMessage});
				return;
			}

			this.resume = data
			this.resumeList = data.entity.resumes && data.entity.resumes
			this.resumeListNum = data.entity.resumes && data.entity.resumes.length
			this.addbaseresumeUrl = data.entity.addResumeLink && data.entity.addResumeLink
			this.daysUse = data.entity.remain
		},
		/**
		 * 点击置顶按钮
		 */
		topBtnClick() {
			window.clickLog && window.clickLog('from=pc-cvip-jlzdsz-tanchuang-ljsy-dj')
			this.postResumeFn(5, this.resumeChose, this.resume.entity.keyid, this.dayChose)
		},
		/**
		 * 设置置顶天数
		 * 剩余置顶天数 daysUse：为 0 时跳转到商业支付（本版本暂时不做，已在公共弹框处阻止点击）
		 * 置顶成功后更新剩余天数 leftTop 的值（leftTop = daysUse - dayChose）
		 */
		postResumeFn(type, rid, keyid, number) {

			if (!rid || !number) {
				this.handleToast("请选择置顶天数");
				return
			}
			postHighLight(type, rid, keyid, number).then((result) => {
				console.log(result);
				if (result.isSuccess) {
					// this.jlzdState = true
					this.$store.commit('LEFT_TOP', this.daysUse - this.dayChose)
					this.$emit('show-alert', '恭喜您，简历置顶设置成功！')
					// window.location.reload()
					this.topBtn()
					// this.close()
					this.$emit('closeDialog')
				} else {
					console.log('网络异常')
				}
			}).catch((err) => {
				console.log('网络异常')
			})
		},
		topBtn() {
			this.$emit('topBtnChange')
		},
		onHide() {
			this.showWarn = false;
			this.showCancelWarn = false;
			this.showDayUseWarn = false;
		},
		onConfirm() {
			window.clickLog && window.clickLog('from=pccvip_zhidingnewclick');
			window.location.href = '//my.58.com/pro/myseekjob/11/';
		}
	},
	computed: {
		stickDaysText3() {
			return [{
					daysid: 1,
					text: '1天'
				},
				{
					daysid: 2,
					text: '2天'
				},
				{
					daysid: this.daysUse,
					text: `${this.daysUse}天`
				}
			]
		}
	},
	components: {
		CvipDialog,
		CvipAlert,
		Toast
	}
};
</script>

<style lang="scss" scoped>
.rtop-dialog-wrap {
    .resume-chose {
        display: block;
        width: 100%;
        margin-top: 50px;
        margin-bottom: 26px;
    }
    .resume-list {
        display: inline-block;
        width: 520px;
        margin-left: 10px;
        .resume {
            display: inline-block;
            width: 180px;
            height: 36px;
            margin-right: 12px;
            margin-bottom: 14px;
            line-height: 36px;
            text-align: center;
            padding: 0 30px;
            overflow: hidden;
            border: 1px solid #eaeaea;
            &:hover {
                border: 1px solid #3f3c37;
            }
        }
		.status-toping {
			color: #afafaf;
		}
    }
    .days-list {
        margin-left: 10px;
        .day {
            display: inline-block;
            width: 130px;
            height: 36px;
            margin-right: 12px;
            text-align: center;
            line-height: 36px;
            border: 1px solid #eaeaea;
            &:hover {
                border: 1px solid #3f3c37;
            }
        }
		.unable-day {
			color: #afafaf;
		}
    }
	.cancel-warn {
		z-index: 9999999;
	}
	.cancel-toast {
		margin: 0 auto;
		border-radius: 10px;
		width: 130px;
		font-size: 18px;
		padding: 18px;
	}
}
</style>



// WEBPACK FOOTER //
// ResumeTopDialog.vue?0fb7614d